import { formatAmount, normalizeAmount } from 'lib/utils/amount';

import Attachment from 'lib/project/classes/Attachment';
import ArrangementStruct from './ArrangementStruct';

class BillTicket {
  constructor(data = {}, options = {
    isMulti: true,
    currency: null,
  }) {
    this.id = data?.id || null;
    this.name = data?.name || null;
    this.description = data?.description || null;
    this.file = new Attachment(data?.file);
    this.amount = this.formatAmount(data?.amount, options?.currency);
    this.arrangement = new ArrangementStruct(data?.arrangement, options.isMulti);
  }

  getAmount(currency) {
    return normalizeAmount(this.amount, currency);
  }

  formatAmount(amount, currency) {
    return formatAmount(amount, {
      significant_zeros: currency?.significant_zeros || 2,
      type: currency?.type || 'DEFAULT',
    });
  }
}

export default BillTicket;
